<template>
    <v-container fluid class="pr-0 pl-0 pb-0 ">
    <v-row
      justify="center"
      no-gutters
    >
      <v-col cols="12" class="text-center mb-0 pb-0">
        <p class="mb-0 pb-0" >{{bottomNote}}</p>
      </v-col>
      <v-col cols="12" class="text-center">
      <p>{{contactEmail}}</p>
      </v-col>
    </v-row>


     <v-footer
    color="primary lighten-1"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="primary lighten-1 py-4 text-center white--text"
        cols="8"
      >
        {{ new Date().getFullYear() }} — <strong>{{copyRigth}}</strong>
        
         
      </v-col>
      <v-col
        class="primary lighten-1 py-4 text-center white--text"
        cols="4"
      >
      <router-link to="/ravintoloille">Ravintoloille</router-link>
         </v-col>  
    </v-row>
  </v-footer>
  </v-container>
</template>

<script>

export default {
    name: 'Footer',
    props: ["copyRigth", "bottomNote", "contactEmail"]
}
</script>


<style scoped>
.v-application a {
  color: black;
  text-decoration: none;
}

</style>>